<mat-drawer-container class="example-container" autosize>
  <!-- <mat-drawer #drawer class="example-sidenav" mode="over" position="end" style="width: 280px;">
    <mat-nav-list>
      <a mat-list-item (click)="downloadApp()">Picaggo App </a>
      <hr>
      <div style="position: relative; bottom: 0; width: 100%">
        <a mat-list-item href="/home">Home</a>
        <a mat-list-item target="_blank" href="https://picaggo.com/EULA.html">User Agreement</a>
        <a mat-list-item target="_blank" href="https://picaggo.com/PrivacyPolicy.html">Privacy Policy</a>
        <a mat-list-item (click)="logout()">Logout
        </a>
      </div>
    </mat-nav-list>
  </mat-drawer> -->

  <div class="example-sidenav-content">
    <!-- <div class="container-fluid" style="
        position: sticky;
        top: 0;
       background-color: #eb3349;
        color: white;
        z-index: 10;
      ">
      <div class="row pt-2 pb-2 align-items-center">
        <div class="col-3 col-sm-3 col-md-3 col-lg-2">
          <a href="#" (click)="gotoHome()">
            <img class="img-icon-css cursor" src="assets/logo white.png" alt=""
              style="height: 30px !important; margin-top: 5px;" />
          </a>

        </div>
        <div class="col-6 col-sm-6 col-md-6 col-lg-8 text-center">
          <span style="position: relative" class="text-uppercase white-color">
            Picaggo
          </span>
        </div>
        <div class="col-3 col-sm-3 col-md-3 col-lg-2 text-end">
          <mat-icon style="z-index: 1" class="cursor" (click)="drawer.toggle()">menu</mat-icon>
        </div>
      </div>
    </div> -->


  </div>
  <!-- <div class="overlay" *ngIf="isLoading">
    <div class="loader_bar"></div>
  </div> -->
  <div class="overlay1" *ngIf="isLoading">
    <div class="ring">
      <svg width="76" height="31" viewBox="0 0 96 41" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path fill-rule="evenodd" clip-rule="evenodd"
          d="M63.7782 2.95119H76.0185V0.975586H63.7782V2.95119ZM18.6251 10.6671C18.6251 9.75786 19.3622 9.02077 20.2715 9.02077H72.7718C73.6811 9.02077 74.4182 9.75786 74.4182 10.6671V32.884C74.4182 33.7932 73.6811 34.5303 72.7718 34.5303H56.6308C59.9348 32.223 62.099 28.3725 62.099 24.0121C62.099 16.9518 56.425 11.2283 49.4257 11.2283C48.5014 11.2283 47.6001 11.3282 46.732 11.5177H27.2898C25.313 11.5177 23.7251 13.1318 23.7251 15.1049V37.3913C23.7251 39.3643 25.313 40.9784 27.2898 40.9784H96V39.0028H27.2898C26.4202 39.0028 25.7007 38.2894 25.7007 37.3913V15.1049C25.7007 14.2067 26.4202 13.4933 27.2898 13.4933H42.2215C38.9171 15.8005 36.7525 19.6513 36.7525 24.0121C36.7525 31.0724 42.4265 36.7959 49.4257 36.7959C50.3511 36.7959 51.2534 36.6959 52.1224 36.5059H72.7718C74.7722 36.5059 76.3938 34.8843 76.3938 32.884V10.6671C76.3938 8.66676 74.7722 7.04517 72.7718 7.04517H20.2715C18.2711 7.04517 16.6495 8.66677 16.6495 10.6671V28.6144C16.6495 29.5237 15.9124 30.2608 15.0032 30.2608H0V32.2364H15.0032C17.0035 32.2364 18.6251 30.6148 18.6251 28.6144V10.6671ZM60.1234 24.0121C60.1234 29.9975 55.3178 34.8203 49.4257 34.8203C43.5337 34.8203 38.7281 29.9975 38.7281 24.0121C38.7281 18.0267 43.5337 13.2039 49.4257 13.2039C55.3178 13.2039 60.1234 18.0267 60.1234 24.0121Z"
          fill="white" />
      </svg>
      <span class="loader"></span>
    </div>
  </div>
  <div class="share-invite">
    <header class="header">
      <button (click)="goBack()" class="back-btn"><svg width="40" height="40" viewBox="0 0 40 40" fill="none"
          xmlns="http://www.w3.org/2000/svg">
          <rect width="40" height="40" rx="20" fill="white" />
          <rect x="0.5" y="0.5" width="39" height="39" rx="19.5" stroke="black" stroke-opacity="0.1" />
          <path d="M28 20H12M12 20L18 14M12 20L18 26" stroke="#131A26" stroke-width="1.5" stroke-linecap="round"
            stroke-linejoin="round" />
        </svg>
      </button>
      <span class="header-title">Event Invite</span>
    </header>
  
    <mat-tab-group class="custom-tabs">
      <!-- Collaborator Tab -->
      <mat-tab label="Collaborator">
        <div class="center-container">

          <div class="qr-section">
            <h3>QR Code for Browser</h3>
            <img class="qr-image" [src]="web_qrImage">
            <div class="qr-box">
              <div class="qr-actions">
                <button (click)="shareWebLink()">
                  <svg xmlns="http://www.w3.org/2000/svg" width="25" height="24" viewBox="0 0 25 24" fill="none">
                    <path
                      d="M16.25 9H18.125C18.6223 9 19.0992 9.19754 19.4508 9.54917C19.8025 9.90081 20 10.3777 20 10.875V19.875C20 20.3723 19.8025 20.8492 19.4508 21.2008C19.0992 21.5525 18.6223 21.75 18.125 21.75H6.875C6.37772 21.75 5.90081 21.5525 5.54917 21.2008C5.19754 20.8492 5 20.3723 5 19.875V10.875C5 10.3777 5.19754 9.90081 5.54917 9.54917C5.90081 9.19754 6.37772 9 6.875 9H8.75M16.25 6L12.5 2.25M12.5 2.25L8.75 6M12.5 2.25V15.0469"
                      stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                  </svg>
                  <span>Share QR</span>
                </button>
                <button (click)="downloadWebImage()">
                  <svg xmlns="http://www.w3.org/2000/svg" width="25" height="24" viewBox="0 0 25 24" fill="none">
                    <path
                      d="M12.7208 16.506C12.6505 16.5829 12.565 16.6442 12.4697 16.6862C12.3744 16.7282 12.2714 16.7499 12.1673 16.7499C12.0631 16.7499 11.9601 16.7282 11.8648 16.6862C11.7695 16.6442 11.684 16.5829 11.6138 16.506L7.61377 12.131C7.4827 11.9837 7.41491 11.7907 7.42507 11.5938C7.43522 11.3969 7.52251 11.2119 7.66803 11.0789C7.81355 10.9459 8.0056 10.8755 8.20262 10.883C8.39965 10.8905 8.58579 10.9753 8.72077 11.119L11.4168 14.069V3C11.4168 2.80109 11.4958 2.61032 11.6364 2.46967C11.7771 2.32902 11.9679 2.25 12.1668 2.25C12.3657 2.25 12.5564 2.32902 12.6971 2.46967C12.8377 2.61032 12.9168 2.80109 12.9168 3V14.068L15.6138 11.118C15.7481 10.9712 15.9352 10.8838 16.134 10.875C16.3328 10.8662 16.527 10.9367 16.6738 11.071C16.8206 11.2053 16.908 11.3925 16.9168 11.5913C16.9256 11.7901 16.8551 11.9842 16.7208 12.131L12.7208 16.506Z"
                      fill="currentColor" />
                    <path
                      d="M3.91675 15C3.91675 14.8011 3.83773 14.6103 3.69708 14.4697C3.55643 14.329 3.36566 14.25 3.16675 14.25C2.96784 14.25 2.77707 14.329 2.63642 14.4697C2.49577 14.6103 2.41675 14.8011 2.41675 15V15.055C2.41675 16.422 2.41675 17.525 2.53375 18.392C2.65375 19.292 2.91375 20.05 3.51475 20.652C4.11675 21.254 4.87475 21.512 5.77475 21.634C6.64175 21.75 7.74475 21.75 9.11175 21.75H15.2217C16.5887 21.75 17.6917 21.75 18.5587 21.634C19.4587 21.512 20.2167 21.254 20.8187 20.652C21.4207 20.05 21.6787 19.292 21.8007 18.392C21.9167 17.525 21.9167 16.422 21.9167 15.055V15C21.9167 14.8011 21.8377 14.6103 21.6971 14.4697C21.5564 14.329 21.3657 14.25 21.1667 14.25C20.9678 14.25 20.7771 14.329 20.6364 14.4697C20.4958 14.6103 20.4167 14.8011 20.4167 15C20.4167 16.435 20.4147 17.436 20.3137 18.192C20.2147 18.926 20.0337 19.314 19.7577 19.591C19.4807 19.868 19.0927 20.048 18.3577 20.147C17.6027 20.248 16.6017 20.25 15.1667 20.25H9.16675C7.73175 20.25 6.72975 20.248 5.97475 20.147C5.24075 20.048 4.85275 19.867 4.57575 19.591C4.29875 19.314 4.11875 18.926 4.01975 18.191C3.91875 17.436 3.91675 16.435 3.91675 15Z"
                      fill="currentColor" />
                  </svg>
                  <span>Download</span>
                </button>
                <button (click)="copyWebLink()">
                  <svg xmlns="http://www.w3.org/2000/svg" width="25" height="24" viewBox="0 0 25 24" fill="none">
                    <path
                      d="M6.8335 11C6.8335 8.172 6.8335 6.757 7.7125 5.879C8.5905 5 10.0055 5 12.8335 5H15.8335C18.6615 5 20.0765 5 20.9545 5.879C21.8335 6.757 21.8335 8.172 21.8335 11V16C21.8335 18.828 21.8335 20.243 20.9545 21.121C20.0765 22 18.6615 22 15.8335 22H12.8335C10.0055 22 8.5905 22 7.7125 21.121C6.8335 20.243 6.8335 18.828 6.8335 16V11Z"
                      stroke="currentColor" stroke-width="1.5" />
                    <path
                      d="M6.8335 19C6.03785 19 5.27478 18.6839 4.71218 18.1213C4.14957 17.5587 3.8335 16.7956 3.8335 16V10C3.8335 6.229 3.8335 4.343 5.0055 3.172C6.1775 2.001 8.0625 2 11.8335 2H15.8335C16.6291 2 17.3922 2.31607 17.9548 2.87868C18.5174 3.44129 18.8335 4.20435 18.8335 5"
                      stroke="currentColor" stroke-width="1.5" />
                  </svg>
                  <span>Copy</span>
                </button>
              </div>
            </div>
            <!-- <div class="link-box">
              <input type="text" [value]="webLink" readonly />
              <button (click)="copyWebLink()">
                <mat-icon>content_copy</mat-icon>
              </button>
            </div> -->
          </div>
          <div class="qr-section">
            <h3>QR Code for App</h3>
            <img class="qr-image" [src]="qrImage">
            <div class="qr-box">
              <div class="qr-actions">
                <button (click)="shareAppLink()">
                  <svg xmlns="http://www.w3.org/2000/svg" width="25" height="24" viewBox="0 0 25 24" fill="none">
                    <path
                      d="M16.25 9H18.125C18.6223 9 19.0992 9.19754 19.4508 9.54917C19.8025 9.90081 20 10.3777 20 10.875V19.875C20 20.3723 19.8025 20.8492 19.4508 21.2008C19.0992 21.5525 18.6223 21.75 18.125 21.75H6.875C6.37772 21.75 5.90081 21.5525 5.54917 21.2008C5.19754 20.8492 5 20.3723 5 19.875V10.875C5 10.3777 5.19754 9.90081 5.54917 9.54917C5.90081 9.19754 6.37772 9 6.875 9H8.75M16.25 6L12.5 2.25M12.5 2.25L8.75 6M12.5 2.25V15.0469"
                      stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                  </svg>
                  <span>Share QR</span>
                </button>
                <button (click)="downloadAppImage()">
                  <svg xmlns="http://www.w3.org/2000/svg" width="25" height="24" viewBox="0 0 25 24" fill="none">
                    <path
                      d="M12.7208 16.506C12.6505 16.5829 12.565 16.6442 12.4697 16.6862C12.3744 16.7282 12.2714 16.7499 12.1673 16.7499C12.0631 16.7499 11.9601 16.7282 11.8648 16.6862C11.7695 16.6442 11.684 16.5829 11.6138 16.506L7.61377 12.131C7.4827 11.9837 7.41491 11.7907 7.42507 11.5938C7.43522 11.3969 7.52251 11.2119 7.66803 11.0789C7.81355 10.9459 8.0056 10.8755 8.20262 10.883C8.39965 10.8905 8.58579 10.9753 8.72077 11.119L11.4168 14.069V3C11.4168 2.80109 11.4958 2.61032 11.6364 2.46967C11.7771 2.32902 11.9679 2.25 12.1668 2.25C12.3657 2.25 12.5564 2.32902 12.6971 2.46967C12.8377 2.61032 12.9168 2.80109 12.9168 3V14.068L15.6138 11.118C15.7481 10.9712 15.9352 10.8838 16.134 10.875C16.3328 10.8662 16.527 10.9367 16.6738 11.071C16.8206 11.2053 16.908 11.3925 16.9168 11.5913C16.9256 11.7901 16.8551 11.9842 16.7208 12.131L12.7208 16.506Z"
                      fill="currentColor" />
                    <path
                      d="M3.91675 15C3.91675 14.8011 3.83773 14.6103 3.69708 14.4697C3.55643 14.329 3.36566 14.25 3.16675 14.25C2.96784 14.25 2.77707 14.329 2.63642 14.4697C2.49577 14.6103 2.41675 14.8011 2.41675 15V15.055C2.41675 16.422 2.41675 17.525 2.53375 18.392C2.65375 19.292 2.91375 20.05 3.51475 20.652C4.11675 21.254 4.87475 21.512 5.77475 21.634C6.64175 21.75 7.74475 21.75 9.11175 21.75H15.2217C16.5887 21.75 17.6917 21.75 18.5587 21.634C19.4587 21.512 20.2167 21.254 20.8187 20.652C21.4207 20.05 21.6787 19.292 21.8007 18.392C21.9167 17.525 21.9167 16.422 21.9167 15.055V15C21.9167 14.8011 21.8377 14.6103 21.6971 14.4697C21.5564 14.329 21.3657 14.25 21.1667 14.25C20.9678 14.25 20.7771 14.329 20.6364 14.4697C20.4958 14.6103 20.4167 14.8011 20.4167 15C20.4167 16.435 20.4147 17.436 20.3137 18.192C20.2147 18.926 20.0337 19.314 19.7577 19.591C19.4807 19.868 19.0927 20.048 18.3577 20.147C17.6027 20.248 16.6017 20.25 15.1667 20.25H9.16675C7.73175 20.25 6.72975 20.248 5.97475 20.147C5.24075 20.048 4.85275 19.867 4.57575 19.591C4.29875 19.314 4.11875 18.926 4.01975 18.191C3.91875 17.436 3.91675 16.435 3.91675 15Z"
                      fill="currentColor" />
                  </svg>
                  <span>Download</span>
                </button>
                <button (click)="copyLink()">
                  <svg xmlns="http://www.w3.org/2000/svg" width="25" height="24" viewBox="0 0 25 24" fill="none">
                    <path
                      d="M6.8335 11C6.8335 8.172 6.8335 6.757 7.7125 5.879C8.5905 5 10.0055 5 12.8335 5H15.8335C18.6615 5 20.0765 5 20.9545 5.879C21.8335 6.757 21.8335 8.172 21.8335 11V16C21.8335 18.828 21.8335 20.243 20.9545 21.121C20.0765 22 18.6615 22 15.8335 22H12.8335C10.0055 22 8.5905 22 7.7125 21.121C6.8335 20.243 6.8335 18.828 6.8335 16V11Z"
                      stroke="currentColor" stroke-width="1.5" />
                    <path
                      d="M6.8335 19C6.03785 19 5.27478 18.6839 4.71218 18.1213C4.14957 17.5587 3.8335 16.7956 3.8335 16V10C3.8335 6.229 3.8335 4.343 5.0055 3.172C6.1775 2.001 8.0625 2 11.8335 2H15.8335C16.6291 2 17.3922 2.31607 17.9548 2.87868C18.5174 3.44129 18.8335 4.20435 18.8335 5"
                      stroke="currentColor" stroke-width="1.5" />
                  </svg>
                  <span>Download</span>
                </button>
              </div>
            </div>
            <!-- <div class="link-box">
              <input type="text" [value]="inviteLink" readonly />
              <button (click)="copyLink()">
                <mat-icon>content_copy</mat-icon>
              </button>
            </div> -->
          </div>

        </div>
      </mat-tab>

      <!-- Viewer Tab -->
      <mat-tab label="Viewer">
        <div class="center-container">
          <div class="qr-section">
            <h3>QR Code for Browser</h3>
            <img class="qr-image" [src]="viewer_web_qrImage">

            <div class="qr-box">
              <div class="qr-actions">
                <button (click)="shareWebViewerLink()">
                  <svg xmlns="http://www.w3.org/2000/svg" width="25" height="24" viewBox="0 0 25 24" fill="none">
                    <path
                      d="M16.25 9H18.125C18.6223 9 19.0992 9.19754 19.4508 9.54917C19.8025 9.90081 20 10.3777 20 10.875V19.875C20 20.3723 19.8025 20.8492 19.4508 21.2008C19.0992 21.5525 18.6223 21.75 18.125 21.75H6.875C6.37772 21.75 5.90081 21.5525 5.54917 21.2008C5.19754 20.8492 5 20.3723 5 19.875V10.875C5 10.3777 5.19754 9.90081 5.54917 9.54917C5.90081 9.19754 6.37772 9 6.875 9H8.75M16.25 6L12.5 2.25M12.5 2.25L8.75 6M12.5 2.25V15.0469"
                      stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                  </svg>
                  <span>Share Link</span>
                </button>
                <button (click)="downloadWebViewerImage()">
                  <svg xmlns="http://www.w3.org/2000/svg" width="25" height="24" viewBox="0 0 25 24" fill="none">
                    <path
                      d="M12.7208 16.506C12.6505 16.5829 12.565 16.6442 12.4697 16.6862C12.3744 16.7282 12.2714 16.7499 12.1673 16.7499C12.0631 16.7499 11.9601 16.7282 11.8648 16.6862C11.7695 16.6442 11.684 16.5829 11.6138 16.506L7.61377 12.131C7.4827 11.9837 7.41491 11.7907 7.42507 11.5938C7.43522 11.3969 7.52251 11.2119 7.66803 11.0789C7.81355 10.9459 8.0056 10.8755 8.20262 10.883C8.39965 10.8905 8.58579 10.9753 8.72077 11.119L11.4168 14.069V3C11.4168 2.80109 11.4958 2.61032 11.6364 2.46967C11.7771 2.32902 11.9679 2.25 12.1668 2.25C12.3657 2.25 12.5564 2.32902 12.6971 2.46967C12.8377 2.61032 12.9168 2.80109 12.9168 3V14.068L15.6138 11.118C15.7481 10.9712 15.9352 10.8838 16.134 10.875C16.3328 10.8662 16.527 10.9367 16.6738 11.071C16.8206 11.2053 16.908 11.3925 16.9168 11.5913C16.9256 11.7901 16.8551 11.9842 16.7208 12.131L12.7208 16.506Z"
                      fill="currentColor" />
                    <path
                      d="M3.91675 15C3.91675 14.8011 3.83773 14.6103 3.69708 14.4697C3.55643 14.329 3.36566 14.25 3.16675 14.25C2.96784 14.25 2.77707 14.329 2.63642 14.4697C2.49577 14.6103 2.41675 14.8011 2.41675 15V15.055C2.41675 16.422 2.41675 17.525 2.53375 18.392C2.65375 19.292 2.91375 20.05 3.51475 20.652C4.11675 21.254 4.87475 21.512 5.77475 21.634C6.64175 21.75 7.74475 21.75 9.11175 21.75H15.2217C16.5887 21.75 17.6917 21.75 18.5587 21.634C19.4587 21.512 20.2167 21.254 20.8187 20.652C21.4207 20.05 21.6787 19.292 21.8007 18.392C21.9167 17.525 21.9167 16.422 21.9167 15.055V15C21.9167 14.8011 21.8377 14.6103 21.6971 14.4697C21.5564 14.329 21.3657 14.25 21.1667 14.25C20.9678 14.25 20.7771 14.329 20.6364 14.4697C20.4958 14.6103 20.4167 14.8011 20.4167 15C20.4167 16.435 20.4147 17.436 20.3137 18.192C20.2147 18.926 20.0337 19.314 19.7577 19.591C19.4807 19.868 19.0927 20.048 18.3577 20.147C17.6027 20.248 16.6017 20.25 15.1667 20.25H9.16675C7.73175 20.25 6.72975 20.248 5.97475 20.147C5.24075 20.048 4.85275 19.867 4.57575 19.591C4.29875 19.314 4.11875 18.926 4.01975 18.191C3.91875 17.436 3.91675 16.435 3.91675 15Z"
                      fill="currentColor" />
                  </svg>
                  <span>Download</span>
                </button>
                <button (click)="copyViewerWebLink()">
                  <svg xmlns="http://www.w3.org/2000/svg" width="25" height="24" viewBox="0 0 25 24" fill="none">
                    <path
                      d="M6.8335 11C6.8335 8.172 6.8335 6.757 7.7125 5.879C8.5905 5 10.0055 5 12.8335 5H15.8335C18.6615 5 20.0765 5 20.9545 5.879C21.8335 6.757 21.8335 8.172 21.8335 11V16C21.8335 18.828 21.8335 20.243 20.9545 21.121C20.0765 22 18.6615 22 15.8335 22H12.8335C10.0055 22 8.5905 22 7.7125 21.121C6.8335 20.243 6.8335 18.828 6.8335 16V11Z"
                      stroke="currentColor" stroke-width="1.5" />
                    <path
                      d="M6.8335 19C6.03785 19 5.27478 18.6839 4.71218 18.1213C4.14957 17.5587 3.8335 16.7956 3.8335 16V10C3.8335 6.229 3.8335 4.343 5.0055 3.172C6.1775 2.001 8.0625 2 11.8335 2H15.8335C16.6291 2 17.3922 2.31607 17.9548 2.87868C18.5174 3.44129 18.8335 4.20435 18.8335 5"
                      stroke="currentColor" stroke-width="1.5" />
                  </svg>
                  <span>Copy</span>
                </button>
              </div>
            </div>
            <!-- <div class="link-box">
              <input type="text" [value]="viewerWebLink" readonly />
              <button (click)="copyViewerWebLink()">
                <mat-icon>content_copy</mat-icon>
              </button>
            </div> -->
          </div>
          <div class="qr-section">
            <h3>QR Code for App</h3>
            <img class="qr-image" [src]="viewer_qrImage">
            <div class="qr-box">

              <div class="qr-actions">
                <button (click)="shareAppViewerLink()">
                  <svg xmlns="http://www.w3.org/2000/svg" width="25" height="24" viewBox="0 0 25 24" fill="none">
                    <path
                      d="M16.25 9H18.125C18.6223 9 19.0992 9.19754 19.4508 9.54917C19.8025 9.90081 20 10.3777 20 10.875V19.875C20 20.3723 19.8025 20.8492 19.4508 21.2008C19.0992 21.5525 18.6223 21.75 18.125 21.75H6.875C6.37772 21.75 5.90081 21.5525 5.54917 21.2008C5.19754 20.8492 5 20.3723 5 19.875V10.875C5 10.3777 5.19754 9.90081 5.54917 9.54917C5.90081 9.19754 6.37772 9 6.875 9H8.75M16.25 6L12.5 2.25M12.5 2.25L8.75 6M12.5 2.25V15.0469"
                      stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                  </svg>
                  <span>Share Link</span>
                </button>
                <button (click)="downloadViewerAppImage()">
                  <svg xmlns="http://www.w3.org/2000/svg" width="25" height="24" viewBox="0 0 25 24" fill="none">
                    <path
                      d="M12.7208 16.506C12.6505 16.5829 12.565 16.6442 12.4697 16.6862C12.3744 16.7282 12.2714 16.7499 12.1673 16.7499C12.0631 16.7499 11.9601 16.7282 11.8648 16.6862C11.7695 16.6442 11.684 16.5829 11.6138 16.506L7.61377 12.131C7.4827 11.9837 7.41491 11.7907 7.42507 11.5938C7.43522 11.3969 7.52251 11.2119 7.66803 11.0789C7.81355 10.9459 8.0056 10.8755 8.20262 10.883C8.39965 10.8905 8.58579 10.9753 8.72077 11.119L11.4168 14.069V3C11.4168 2.80109 11.4958 2.61032 11.6364 2.46967C11.7771 2.32902 11.9679 2.25 12.1668 2.25C12.3657 2.25 12.5564 2.32902 12.6971 2.46967C12.8377 2.61032 12.9168 2.80109 12.9168 3V14.068L15.6138 11.118C15.7481 10.9712 15.9352 10.8838 16.134 10.875C16.3328 10.8662 16.527 10.9367 16.6738 11.071C16.8206 11.2053 16.908 11.3925 16.9168 11.5913C16.9256 11.7901 16.8551 11.9842 16.7208 12.131L12.7208 16.506Z"
                      fill="currentColor" />
                    <path
                      d="M3.91675 15C3.91675 14.8011 3.83773 14.6103 3.69708 14.4697C3.55643 14.329 3.36566 14.25 3.16675 14.25C2.96784 14.25 2.77707 14.329 2.63642 14.4697C2.49577 14.6103 2.41675 14.8011 2.41675 15V15.055C2.41675 16.422 2.41675 17.525 2.53375 18.392C2.65375 19.292 2.91375 20.05 3.51475 20.652C4.11675 21.254 4.87475 21.512 5.77475 21.634C6.64175 21.75 7.74475 21.75 9.11175 21.75H15.2217C16.5887 21.75 17.6917 21.75 18.5587 21.634C19.4587 21.512 20.2167 21.254 20.8187 20.652C21.4207 20.05 21.6787 19.292 21.8007 18.392C21.9167 17.525 21.9167 16.422 21.9167 15.055V15C21.9167 14.8011 21.8377 14.6103 21.6971 14.4697C21.5564 14.329 21.3657 14.25 21.1667 14.25C20.9678 14.25 20.7771 14.329 20.6364 14.4697C20.4958 14.6103 20.4167 14.8011 20.4167 15C20.4167 16.435 20.4147 17.436 20.3137 18.192C20.2147 18.926 20.0337 19.314 19.7577 19.591C19.4807 19.868 19.0927 20.048 18.3577 20.147C17.6027 20.248 16.6017 20.25 15.1667 20.25H9.16675C7.73175 20.25 6.72975 20.248 5.97475 20.147C5.24075 20.048 4.85275 19.867 4.57575 19.591C4.29875 19.314 4.11875 18.926 4.01975 18.191C3.91875 17.436 3.91675 16.435 3.91675 15Z"
                      fill="currentColor" />
                  </svg>
                  <span>Download</span>
                </button>
                <button (click)="copyViewerAppLink()">
                  <svg xmlns="http://www.w3.org/2000/svg" width="25" height="24" viewBox="0 0 25 24" fill="none">
                    <path
                      d="M6.8335 11C6.8335 8.172 6.8335 6.757 7.7125 5.879C8.5905 5 10.0055 5 12.8335 5H15.8335C18.6615 5 20.0765 5 20.9545 5.879C21.8335 6.757 21.8335 8.172 21.8335 11V16C21.8335 18.828 21.8335 20.243 20.9545 21.121C20.0765 22 18.6615 22 15.8335 22H12.8335C10.0055 22 8.5905 22 7.7125 21.121C6.8335 20.243 6.8335 18.828 6.8335 16V11Z"
                      stroke="currentColor" stroke-width="1.5" />
                    <path
                      d="M6.8335 19C6.03785 19 5.27478 18.6839 4.71218 18.1213C4.14957 17.5587 3.8335 16.7956 3.8335 16V10C3.8335 6.229 3.8335 4.343 5.0055 3.172C6.1775 2.001 8.0625 2 11.8335 2H15.8335C16.6291 2 17.3922 2.31607 17.9548 2.87868C18.5174 3.44129 18.8335 4.20435 18.8335 5"
                      stroke="currentColor" stroke-width="1.5" />
                  </svg>
                  <span>Copy</span>
                </button>
              </div>
            </div>
            <!-- <div class="link-box">
              <input type="text" [value]="viewerLink" readonly />
              <button (click)="copyViewerAppLink()">
                <mat-icon>content_copy</mat-icon>
              </button>
            </div> -->
          </div>


        </div>
      </mat-tab>
    </mat-tab-group>

  </div>
  <!-- <div>
    <div class="contact-list-container">
      <div class="contact-header">
        <h2>Contact List</h2>
        <div class="search-add">
          <input type="text" class="search-bar" placeholder="Search contacts..." [(ngModel)]="searchQuery"
            (input)="searchContacts($event)" />
          <button class="add-contact-btn" (click)="openAddContactPopup()">
            + Add
          </button>
        </div>
      </div>

      <div *ngIf="filteredContacts.length === 0">
        <p>No results found for "{{ searchQuery }}".</p>
        <button class="add-contact-btn" (click)="openAddContactPopup()">
          Add "{{ searchQuery }}" as a new contact
        </button>
      </div>
  
      <div class="contact-list" *ngIf="filteredContacts.length > 0">
        <div class="contact-item" *ngFor="let contact of filteredContacts; let i = index">
          <label class="contact-checkbox">
            <input type="checkbox" [(ngModel)]="contact.selected" (change)="onSelectPreviousContact(i)" />
            <span class="checkmark"></span>
          </label>
          <div class="contact-details">
            <h3>{{ contact.name }}</h3>
            <p><strong>Phone:</strong> {{ contact.phone_number || 'N/A' }}</p>
            <p><strong>Email:</strong> {{ contact.email_address || 'N/A' }}</p>
          </div>
        </div>
      </div>
      <div class="popup" *ngIf="isAddContactPopupOpen">
        <div class="popup-content">
          <span class="close-btn" (click)="closeAddContactPopup()">×</span>
          <h3> {{ editIndex !== null ? 'Update Contact' : 'Add New Contact' }} </h3>
          <form [formGroup]="contactForm" (ngSubmit)="saveContact(null)">
            <mat-form-field>
              <input matInput placeholder="Name" formControlName="name" />
              <mat-error *ngIf="contactForm.get('name')?.hasError('required')">
                Name is required
              </mat-error>
            </mat-form-field>

            <mat-form-field>
              <input matInput placeholder="Phone" formControlName="phone_number" />
              <mat-error *ngIf="contactForm.get('phone_number')?.hasError('pattern')">
                Enter a valid phone number
              </mat-error>
            </mat-form-field>

            <mat-form-field>
              <input matInput placeholder="Email" formControlName="email_address" />
              <mat-error *ngIf="contactForm.get('email_address')?.hasError('email')">
                Enter a valid email
              </mat-error>
            </mat-form-field>
            <button mat-raised-button color="primary" type="submit" style="display: block;left: 22%;"
              [disabled]="!contactForm.valid">
              {{ editIndex !== null ? 'Update Contact' : 'Add Contact' }}
            </button>
        
          </form>
        </div>
      </div>
    </div>

  </div>

  <div class="invitation-list">
    <h3>Send Invitations</h3>
    <div class="invitation-item" *ngFor="let invite of contacts; let i = index">
      <div class="invitation-name">
        {{ invite.name }}
      </div>
      <div class="invitation-actions">
        <button class="edit-btn" (click)="onEditContact(i)">✏️</button>
        <button class="delete-btn" (click)="onDeleteContact(i, invite.id)">❌</button>
      </div>
    </div>
  </div> -->

  <div style="text-align: center;">
    <button (click)="gotoHome()" class="home-btn">Home</button>
    <button (click)="saveAndgotoHome()" class="continue-btn">Continue</button>
  </div>
</mat-drawer-container>